<template>
    <div class="all-area">
        <div class="page">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-cell v-for="item in youhuiList" :key="item"  class="notice-item">
                    <van-row  type="flex" justify="space-between" align="center">
                        <van-col>
                            <van-row type="flex" align="center">
                                <van-col class="price-info">
                                    <van-row class="price-value">¥{{item.price}}</van-row>
                                    <van-row class="price-notice">优惠券</van-row>
                                </van-col>
                                <van-col class="time-info">
                                    <van-row class="time-value">有效期至{{item.expiryDate}}</van-row>
                                    <van-row class="time-status">未使用</van-row>
                                </van-col>
                            </van-row>
                        </van-col>
                        <van-col class="action" @click="chooseYouhui">
                            立即使用
                        </van-col>
                    </van-row>

                </van-cell>
            </van-list>
        </div>
    </div>

</template>

<script>
    import {getYouhui} from '@/api/api'
    export default {
        name: "youhuiquan",
        data(){
            return{
                loading:false,
                finished:true,
                youhuiList:[]
            }
        },
        created(){
            this.getList()
        },
        methods:{
            onLoad(){

            },
            getList(){
                let params = {
                    pageNo:1,
                    pageSize:50
                }
                getYouhui(params).then(res=>{
                    if (res.code==0){
                        this.youhuiList = res.data.list
                    }
                })
            },
            chooseYouhui(){
                let youhuiInfo = this.youhuiList[0]
                localStorage.setItem('youhui',youhuiInfo.value)
                this.$router.back()
            }
        }
    }
</script>

<style scoped>
    .all-area{
        position: absolute;
        width: 100%;
        height: 100%;
        background:rgba(245,245,245,1);
    }
    .page{
        margin-top: 25px;
        margin-left: 16px;
        margin-right: 16px;
    }
    .notice-item{
        width:100%;
        height:90px;
        background:rgba(255,255,255,1);
        border-radius:12px;
        margin-bottom: 16px;
    }
    .price-info{
        margin-right: 30px;
    }
    .price-value{
        font-size:24px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(255,129,80,1);
        line-height:33px;
    }
    .price-notice{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,129,80,1);
        line-height:17px;
    }
    .time-value{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:17px;
        margin-bottom: 6px;
    }
    .time-status{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:17px;
    }
    .action{
        width:72px;
        height:33px;
        background:rgba(255,129,80,1);
        box-shadow:0px 2px 8px 0px rgba(255,129,80,0.2);
        border-radius:25px;
        font-size:12px;
        font-family:PingFangTC-Semibold,PingFangTC;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:33px;
        text-align: center;
    }
</style>